<template>
  <div>
    LANGUAGE LISTING
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>